import { z } from 'zod';

/**
 * How this deployment is managed. Advisory: it drives display concerns (the
 * Device Info dialog's field set) and documents the intended provisioning
 * path — it does NOT decide which native bridge is used at runtime. The
 * launcher picks its host by probing what's actually present on the device
 * (see `selectAgentHost`), so a device is never stranded by a stale `mdm`
 * value.
 *
 *   - `androidEnterprise` — the deployment backbone. The native Android shell
 *                     runs as a HOME app under lock task and is provisioned by
 *                     managed configuration (Android Enterprise / AMAPI). No
 *                     third-party MDM required; an EMM/AMAPI simply pushes the
 *                     managed config. The default for dedicated-device fleets.
 *   - `mobicontrol` — deployed inside a SOTI MobiControl Lockdown Profile.
 *                     SOTI's JS Agent API is present, so its host backs the
 *                     agent-action tiles and supplies MDM-only Device Info
 *                     fields (IMEI, Wi-Fi SSID, carrier, signal). SOTI is one
 *                     adapter here, not the foundation.
 *   - `none`        — unmanaged: the standalone Android app sideloaded, or a
 *                     bare browser. Device Info shows only what the Android
 *                     system API + WebView can supply; nothing pretends to be
 *                     MDM-sourced.
 *
 * Default is `none` for un-provisioned installs; managed deployments set
 * `androidEnterprise` (backbone) or `mobicontrol` (SOTI).
 */
export const Mdm = z.enum(['androidEnterprise', 'mobicontrol', 'none']);
export type Mdm = z.infer<typeof Mdm>;
